import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

const MAXIMUM_LENGTH = 100

// Personal Information Step Schema
export const personalInformationStepSchema = () =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .max(
        MAXIMUM_LENGTH,
        i18n.t('benefits.healthcare.plan_wizard.validation.common.max_length', {
          max: MAXIMUM_LENGTH,
        })
      ),

    lastName: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .max(
        MAXIMUM_LENGTH,
        i18n.t('benefits.healthcare.plan_wizard.validation.common.max_length', {
          max: MAXIMUM_LENGTH,
        })
      ),

    sex: z.enum(['male', 'female'], {
      required_error: i18n.t('benefits.healthcare.plan_wizard.validation.common.required'),
    }),

    birthday: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .refine((date) => {
        const birthDate = new Date(date)
        const now = new Date()
        return birthDate <= now
      }, i18n.t('benefits.healthcare.enrollment_wizard.validation.common.date_not_in_past')),

    addressLine1: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .max(
        MAXIMUM_LENGTH,
        i18n.t('benefits.healthcare.plan_wizard.validation.common.max_length', {
          max: MAXIMUM_LENGTH,
        })
      ),

    addressLine2: z
      .string()
      .trim()
      .max(
        MAXIMUM_LENGTH,
        i18n.t('benefits.healthcare.plan_wizard.validation.common.max_length', {
          max: MAXIMUM_LENGTH,
        })
      )
      .optional(),

    postalCode: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required')),
    city: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required')),

    province: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required')),

    taxIdNumber: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required')),

    // We will need to generalize this better to expand to new markets
    taxIdType: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required')),

    email: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .email(i18n.t('benefits.healthcare.enrollment_wizard.validation.common.invalid_email'))
      .max(
        MAXIMUM_LENGTH,
        i18n.t('benefits.healthcare.plan_wizard.validation.common.max_length', {
          max: MAXIMUM_LENGTH,
        })
      ),

    phoneNumber: z
      .string()
      .trim()
      .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
      .regex(
        /^\+[\d \-\(\)]+$/,
        i18n.t('benefits.healthcare.enrollment_wizard.validation.phone_number.invalid_format')
      ),

    iban: z
      .string()
      .transform((value) => value.replace(/\s/g, ''))
      .pipe(
        z
          .string()
          .min(1, i18n.t('benefits.healthcare.plan_wizard.validation.common.required'))
          .min(6, i18n.t('benefits.healthcare.enrollment_wizard.validation.invalid_iban'))
          .max(34, i18n.t('benefits.healthcare.enrollment_wizard.validation.invalid_iban'))
          .regex(
            /^(?=.{15,34}$)[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/,
            i18n.t('benefits.healthcare.enrollment_wizard.validation.invalid_iban')
          )
      ),

    saveToProfile: z.boolean().optional(),
  })
